import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-04da7dee")

_pushScopeId("data-v-04da7dee")
const _hoisted_1 = { class: "dashboard" }
const _hoisted_2 = { class: "display-flex board-content" }
const _hoisted_3 = { class: "display-flex board-content" }
const _hoisted_4 = { class: "display-flex board-content" }
const _hoisted_5 = { class: "display-flex board-content" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "flex1" }, null, -1)
const _hoisted_7 = { class: "display-flex board-content" }
const _hoisted_8 = { class: "card-chart" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "chart-content" }, [
  /*#__PURE__*/_createVNode("div", {
    id: "to-day-count",
    class: "container margin-top35px"
  })
], -1)
const _hoisted_10 = { class: "card-chart" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "chart-content" }, [
  /*#__PURE__*/_createVNode("div", {
    id: "to-year-count",
    class: "container margin-top35px"
  })
], -1)
const _hoisted_12 = { class: "display-flex board-content" }
const _hoisted_13 = { class: "card-list flex3" }
const _hoisted_14 = { class: "padding-top15px" }
const _hoisted_15 = { class: "card-list flex3" }
const _hoisted_16 = { class: "card-list flex3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_item_title = _resolveComponent("item-title")
  const _component_card_icon = _resolveComponent("card-icon")
  const _component_card_text = _resolveComponent("card-text")
  const _component_card_rich = _resolveComponent("card-rich")
  const _component_card_list = _resolveComponent("card-list")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_item_title, {
      name: _ctx.$wordList.DarshbordCommunityInfo
    }, null, 8, ["name"]),
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.communityInfoCardData, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          class: "margin-right20px flex1",
          key: index
        }, [
          _createVNode(_component_card_icon, {
            "card-data": item,
            text: _ctx.communityData[item.name],
            onClick: () => {
                        if(item.enable) _ctx.goPath(item.path)
                    }
          }, null, 8, ["card-data", "text", "onClick"])
        ]))
      }), 128))
    ]),
    _createVNode(_component_item_title, {
      name: _ctx.$wordList.DarshbordDeviceInfo
    }, null, 8, ["name"]),
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deviceInfoCardData, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          class: "margin-right20px flex1",
          key: index
        }, [
          _createVNode(_component_card_icon, {
            "card-data": item,
            text: _ctx.communityData[item.name],
            onClick: () => {
                        if(item.enable) _ctx.goPath(item.path)
                    }
          }, null, 8, ["card-data", "text", "onClick"])
        ]))
      }), 128))
    ]),
    _createVNode(_component_item_title, {
      name: _ctx.$wordList.DarshbordResidentInfo
    }, null, 8, ["name"]),
    _createVNode("div", _hoisted_4, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.residentInfoCardData, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          class: "margin-right20px flex1",
          key: index,
          onClick: () => {
                     if(item.enable) _ctx.goPath(item.path)
                 }
        }, [
          _createVNode(_component_card_text, {
            title: item.title,
            text: _ctx.communityData[item.name],
            enable: item.enable
          }, null, 8, ["title", "text", "enable"])
        ], 8, ["onClick"]))
      }), 128))
    ]),
    _createVNode(_component_item_title, {
      name: _ctx.$wordList.DeviceDetailDetailOthers
    }, null, 8, ["name"]),
    _createVNode("div", _hoisted_5, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.otherCardData, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          class: "margin-right20px flex1",
          key: index
        }, [
          _createVNode(_component_card_rich, {
            title: item.title,
            text: _ctx.communityData[item.name],
            "card-data": item
          }, null, 8, ["title", "text", "card-data"])
        ]))
      }), 128)),
      _hoisted_6
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_item_title, {
          name: _ctx.$wordList.DarshbordTodayCount.format(_ctx.communityData.todayCount)
        }, null, 8, ["name"]),
        _hoisted_9
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode(_component_item_title, {
          name: _ctx.$wordList.DarshbordYearCount.format(_ctx.communityData.yearCount)
        }, null, 8, ["name"]),
        _hoisted_11
      ])
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode("div", _hoisted_13, [
        _createVNode(_component_item_title, {
          name: _ctx.$wordList.DarshbordLastLog,
          "sub-name": _ctx.lastDoorLogList.length === 0 ? '0/0': `${_ctx.doorIndex+1}/${_ctx.lastDoorLogList.length}`
        }, null, 8, ["name", "sub-name"]),
        _createVNode(_component_card_list, {
          list: _ctx.lastDoorLogList[_ctx.doorIndex]
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_14, [
              _createVNode("i", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeDoorList(1))),
                class: ['el-icon-arrow-left', _ctx.doorIndex === 0 ? 'card-arrow-disable' : 'card-arrow','float-left']
              }, null, 2),
              _createVNode("i", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeDoorList(2))),
                class: ['el-icon-arrow-right',
                                    _ctx.doorIndex === _ctx.lastDoorLogList.length-1 || _ctx.lastDoorLogList.length === 0
                                        ?'card-arrow-disable' : 'card-arrow', 'float-right'],
                style: {"float":"right"}
              }, null, 2)
            ])
          ]),
          _: 1
        }, 8, ["list"])
      ]),
      _createVNode("div", _hoisted_15, [
        _createVNode(_component_item_title, {
          name: _ctx.$wordList.DarshbordWeekLog
        }, null, 8, ["name"]),
        _createVNode(_component_card_list, {
          type: "green",
          list: _ctx.weekData
        }, null, 8, ["list"])
      ]),
      _createVNode("div", _hoisted_16, [
        _createVNode(_component_item_title, {
          name: _ctx.$wordList.DarshbordCommunityDetail
        }, null, 8, ["name"]),
        _createVNode(_component_card_list, {
          type: "orange",
          list: _ctx.detailList
        }, null, 8, ["list"])
      ])
    ])
  ]))
})